import { useEffect, useState } from 'react';
import { FaHandHoldingHeart } from "react-icons/fa6";
import { BackendLink, SmartServiceCard } from "../../../Components";
import 'react-loading-skeleton/dist/skeleton.css';
import './ServicesSection.css';

const ServicesSection = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Fetch data from the server
    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllServices/`);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setServices(data);
            } catch (error) {
                console.error('Error fetching services:', error);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <div className='services-section' data-aos="fade-up">
            <h1 className="section-title">
                Our Services <FaHandHoldingHeart size={40} />
            </h1>

        <div className="all-servicesCard">
            {loading || error || services.length === 0
                ? Array.from({ length: 7 }).map((_, idx) => (
                    <SmartServiceCard
                        key={idx}
                        loading={loading}
                        error={error || services.length === 0}
                        service={null}
                    />
                ))
                : services.map(service => (
                    <SmartServiceCard
                        key={service.id}
                        loading={false}
                        error={false}
                        service={service}
                    />
                ))
            }
        </div>
        </div>
    );
};

export default ServicesSection;
